import React, { useState } from 'react'
import styles from './Login.module.scss'
import { Link, Navigate } from 'react-router-dom'
import api from '../../api'
import { useSelector } from '../../store'

const Login = () => {
  const isAuth = useSelector((state) => state.profile.isAuth)
  const [email, setEmail] = useState<string | undefined>()
  const [password, setPassword] = useState<string | undefined>()
  const [loginRequest, loginResponse] = api.useLoginMutation()
  const requestError = loginResponse.isError || (loginResponse.data !== undefined && 'error' in loginResponse.data)
  const btnDisabled = email === undefined || password === undefined || loginResponse.isLoading

  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (email !== undefined && password !== undefined) loginRequest({ email, password })
  }

  if (isAuth) {
    return <Navigate to={'/'} />
  } else {
    return (
      <div className={styles.page}>
        <form className={styles.form} onSubmit={onSubmit}>
          <h1 className={styles.title}>Log In</h1>
          <input
            className={styles.input}
            placeholder={'Email or Username'}
            type={'text'}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <input
            className={styles.input}
            placeholder={'Password'}
            type={'password'}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <div style={{ position: 'relative' }}>
            {requestError && <p className={styles.error}>Login error</p>}
            <button className={styles.submitBtn} type={'submit'} disabled={btnDisabled}>
              Log In
            </button>
          </div>
        </form>
      </div>
    )
  }
}

export default Login
